export const SET_TITLE = "SET_TITLE";
export const SET_IS_BREADCRUMB_SHOWN = "SET_IS_BREADCRUMB_SHOWN";